import { get } from 'lodash';
import cashierApis from 'modules/POS/services/apis';
import { IApiCashierPaymentBody } from 'modules/POS/services/types/payment';
import { IResponseData } from 'services/response';
import toast from 'utils/toast';
import { cashierCtrl } from '../../cashier.controller';
import CashierActionButton, { ActionType } from '../../components/CashierActionButton';
import ModalCardPayment, { ICashierCardPaymentMethod, useModalCardPaymentRef } from './ModalCardPayment';
import { IUICashierFormValues } from '../../cashier.interface';
type Props = {
  enableCardFee?: IUICashierFormValues['chargeFee'];
  feeCreditCard?: IUICashierFormValues['feeCreditCard'];
  feeCreditCardAmount?: IUICashierFormValues['feeCreditCardAmount'];
};
const CashierCardPayment = ({ enableCardFee, feeCreditCard, feeCreditCardAmount }: Props) => {
  const ref = useModalCardPaymentRef();

  const onCancelPayment = () => undefined;
  const onCompletedTicket = () => {
    cashierCtrl.generateNewTicketAfterPayment();
  };
  const onPayment: ICashierCardPaymentMethod = async (billId, paymentItem) => {
    const body: IApiCashierPaymentBody = {
      billId, payments: [paymentItem],
    };
    try {
      const res: IResponseData<any> = await cashierApis.paymentTicket(body);
      if (res.data.data) {
        return true;
      }
      throw res.data.data;
    } catch (error) {
      const msg = get(error, ['response', 'data', 'message'], 'Fail');
      toast.error(msg);
      return false;
    }
  };

  const onCard = () => cashierCtrl.saveTicketPaymentWithCallBack((billId) => {
    if (billId) ref.current?.open(billId);
  });

  return (
    <>
      <CashierActionButton
        type={ActionType.CARD}
        onClick={onCard}
      />
      <ModalCardPayment
        ref={ref}
        onCancel={onCancelPayment}
        onPayment={onPayment}
        onCompletedTicket={onCompletedTicket}
        enableCardFee={enableCardFee}
        feeCreditCard={feeCreditCard}
        feeCreditCardAmount={feeCreditCardAmount}
      />
    </>
  );
};

export default CashierCardPayment;
